"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { withSlotScopeClasses } from '../../../helpers/scoped-slots.mjs';
import { useMemo } from 'react';
import { tv } from 'tailwind-variants';

const fieldNameInputRecipe = tv({
  slots: withSlotScopeClasses("field-name-input", {
    wrapper: "inline-block cursor-default relative",
    span: "block visible empty:after:content-[var(--placeholder-text)] empty:after:text-fg-disabled",
    input: "appearance-none bg-transparent absolute inset-0 w-full transition-colors p-0 m-0 border-t-transparent opacity-0 hover:opacity-100 focus:opacity-100 focus:outline-none"
  })
});
const fieldNameInputClassNames = fieldNameInputRecipe();
function FieldNameInput({
  value,
  className,
  placeholder = "Enter some text",
  onChange = () => {
  },
  onEnter = () => {
  },
  onEsc = () => {
  },
  onFocus = () => {
  },
  onBlur = () => {
  },
  editable = true,
  autoFocus = false,
  ...props
}) {
  const handleChange = (event) => {
    onChange(event.target.value);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.currentTarget.blur();
      onEnter?.(value);
      return;
    }
    if (event.key === "Escape") {
      event.currentTarget.blur();
      onEsc?.(value);
      return;
    }
  };
  const handleFocus = (event) => {
    onFocus(event.target.value);
  };
  const handleBlur = (event) => {
    onChange(event.target.value);
    onBlur(event.target.value);
  };
  const style = useMemo(
    () => ({
      "--placeholder-text": `"${placeholder}"`
    }),
    [placeholder]
  );
  const classNames = clsx(fieldNameInputClassNames.wrapper(), className);
  return /* @__PURE__ */ jsxs("span", { className: classNames, ...props, title: value, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        className: fieldNameInputClassNames.input(),
        onChange: handleChange,
        value,
        placeholder,
        "aria-label": placeholder,
        readOnly: !editable,
        autoFocus,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown
      }
    ),
    /* @__PURE__ */ jsx("span", { className: fieldNameInputClassNames.span(), style, children: value?.replace(/\s/g, "\xA0") })
  ] });
}

export { FieldNameInput };
